// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-3d"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 3L18 6.5V13.5L12 17L6 13.5V6.5L12 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M5.4 12.2437C3.31551 13.16 2 14.5032 2 16.0001C2 18.7615 6.47715 21.0001 12 21.0001C17.5228 21.0001 22 18.7615 22 16.0001C22 14.5032 20.6845 13.16 18.6 12.2437","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 10L17.6667 6.85M12 10V16.65M12 10L6.33333 6.85M12 3L18 6.5V13.5L12 17L6 13.5V6.5L12 3Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-3d')
export default class Map3DIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-3d',
    }
  }
}
